<template>
  <LoaderFullPage v-if="store.loadingEvents" />
  <template v-else-if="store.events.length > 0">
    <div class="events-params">
      <div>Total: {{ store.eventsCount }}</div>
      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Événements par page :"
      />
    </div>
    <ul class="events-list">
      <li v-for="event in store.events" :key="event._id">
        <ReunionCard :reunion="event" />
      </li>
    </ul>

    <PaginationElement
      v-if="store.eventsCount"
      :key="`${store.eventsCount}${store.eventsFilters.from}${store.eventsFilters.size}`"
      :total-items="store.eventsCount"
      :current-page="store.eventsFilters.from"
      :items-limit="store.eventsFilters.size"
      @change-current-page="changeCurrentPage"
    />
  </template>
  <div v-else class="empty">
    <img
      src="@/assets/img/institutional-groups/empty-states/commissions-agendas-nodatas.svg"
      alt="aria-hidden=true"
    />
    <p>Aucun évènement prévu pour cet organe.</p>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import ReunionCard from "@follaw-fr/components/legi-work/atoms/ReunionCard.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import { useInstituGroupsStore } from "@follaw-fr/stores/institutional-groups";

const store = useInstituGroupsStore();
const { eventsFilters } = storeToRefs(store);

const fetchAgenda = async () => {
  await store.fetchAgenda(store.missionZoom?.ref || store.groupZoom?.ref);
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: eventsFilters,
    filterKey: "size",
    onChange: () => {
      store.eventsFilters.from = 0;
      fetchAgenda();
    },
  });

const changeCurrentPage = (from) => {
  store.eventsFilters.from = from;
  fetchAgenda();
};

fetchAgenda();
</script>

<style scoped lang="scss">
.empty > img {
  max-width: 289px;
}
.events-params {
  display: flex;
  justify-content: space-between;
}

.events-list {
  list-style: none;
  padding: 0;
  margin: 0;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px;

  :deep(.card) {
    display: flex;
    flex-direction: column;
    height: 100%;

    .signatures {
      font-weight: 300;
    }

    .body {
      flex-grow: 1;

      display: flex;
      flex-direction: column;
      gap: 15px;

      .link {
        margin-top: auto;
        align-self: flex-end;
      }
    }
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px auto;
  font-size: 1.125em;
  flex-direction: column;
  p {
    max-width: 31.3125em;
    text-align: center;
    font-weight: 700;
    font-size: 1.125em;
    color: var(--clr-n8);
  }
  small {
    font-size: 1em;
  }
}
</style>
